import { AccordionItem } from '@e3dc-react/shell/Elements/Accordion'
import { IconButton } from '@mui/material'
import { Box } from '@mui/system'
import { Formik } from 'formik'
import React, { useState } from 'react'
import SmartMeterForm, { SmartMeterFormValues } from './SmartMeterForm'
import SmartMeterUpload, { SmartMeterFileProps } from './SmartMeterUpload'
import { J2Delete, J2Launchapp } from '@e3dc-react/icons'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import useSmartMeterValidation from 'src/Libs/shop/hooks/validation/use-smart-meter-validation'
import { makeStyles } from 'tss-react/mui'
import { LoadingButton } from '@mui/lab'
import { isEqual } from 'lodash'

interface EditExistingSmartMeterAccordionProps {
  documentId: string
  existingfileName: string
  smartMeterCartId: string
  initialValues: SmartMeterFormValues
  isLoading: boolean
  onOpenFile: (smartMeterId: string, contractId: string) => void
  onDeleteFile: (smartMeterId: string, contractId: string) => void
  onModifyFile: (smartMeterId: string, contractId: string, contractFile: Blob | null, contractData: SmartMeterFormValues) => void
}

const useStyles = makeStyles()(theme => ({
  accordion: {
    minWidth: '100%',
  },
  formWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
  },
  formContainer: {
    display: 'flex',
    gap: theme.spacing(2),
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  accordionContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
}))

/*
 * This component renders an acordion for a smartmeter added contract
 */
const EditExistingSmartMeterAccordion: React.FC<EditExistingSmartMeterAccordionProps> = ({
  documentId,
  existingfileName,
  smartMeterCartId,
  initialValues,
  isLoading,
  onOpenFile,
  onDeleteFile,
  onModifyFile,
}) => {
  const { t } = useCustomTranslation()
  const { validationSchema } = useSmartMeterValidation()
  const { classes } = useStyles()
  const [selectedContract, setSelectedContract] = useState<SmartMeterFileProps>({ file: null, fileName: existingfileName })
  return (
    <AccordionItem
      depth={1}
      className={classes.accordion}
      expandOnlyOnIcon
      key={documentId}
      title={existingfileName}
      headerChildren={
        <Box className={classes.accordionContainer}>
          <IconButton onClick={() => onOpenFile(smartMeterCartId, documentId)}>
            <J2Launchapp />
          </IconButton>
          <IconButton onClick={() => onDeleteFile(smartMeterCartId, documentId)}>
            <J2Delete />
          </IconButton>
        </Box>
      }
    >
      <Box className={classes.formWrapper}>
        <Box className={classes.formContainer}>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={values => onModifyFile(smartMeterCartId, documentId, selectedContract.file, values)}
          >
            {({ values, isValid, handleSubmit }) => {
              const isUnchanged = isEqual(values, initialValues)
              const disableSubmit = !isValid || (!selectedContract.file && isUnchanged)
              return (
                <form onSubmit={handleSubmit}>
                  <Box className={classes.container}>
                    <SmartMeterUpload selectedFile={selectedContract} onFileChange={file => setSelectedContract(file)} />
                    <SmartMeterForm />
                    <LoadingButton loading={isLoading} type="submit" disabled={disableSubmit} variant="contained">
                      {t('shop.smart-meter-document.update-label')}
                    </LoadingButton>
                  </Box>
                </form>
              )
            }}
          </Formik>
        </Box>
      </Box>
    </AccordionItem>
  )
}

export default EditExistingSmartMeterAccordion
